import { render, staticRenderFns } from "./shopCard.vue?vue&type=template&id=092af7a6&scoped=true"
import script from "./shopCard.vue?vue&type=script&lang=js"
export * from "./shopCard.vue?vue&type=script&lang=js"
import style0 from "./shopCard.vue?vue&type=style&index=0&id=092af7a6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "092af7a6",
  null
  
)

export default component.exports